import { createAction, ActionsUnion } from "common/reducers/UtilsTypes";
import { IDabellaCustomFormData } from "common/records/DabellaCustomForm";
import { FormUpdateEvent } from "common/reducers/rsfForm.actions";

export const FETCH_CUSTOM_FORM = "@dabellaCustomForm/FETCH_CUSTOM_FORM";
export const RECEIVE_CUSTOM_FORM = "@dabellaCustomForm/RECEIVE_CUSTOM_FORM";
export const RECEIVE_CUSTOM_FORMS = "@dabellaCustomForm/RECEIVE_CUSTOM_FORMS";
export const SET_APPLICANT_COUNT = "@dabellaCustomForm/SET_APPLICANT_COUNT";
export const UPDATE_DABELLA_FORM = "@dabellaCustomForm/UPDATE_DABELLA_FORM";
export const RESET_DABELLA_FORM = "@dabellaCustomForm/RESET_DABELLA_FORM";
export const CLEANUP_DABELLA_FORM = "@dabellaCustomForm/CLEANUP_DABELLA_FORM";

export const DabellaCustomFormActions = {
  fetchCustomForm: (id: string) => createAction(FETCH_CUSTOM_FORM, { id }),
  receiveCustomForm: (customForm: Partial<IDabellaCustomFormData>) => createAction(RECEIVE_CUSTOM_FORM, { customForm }),
  receiveCustomForms: (customForms: Partial<IDabellaCustomFormData>[]) =>
    createAction(RECEIVE_CUSTOM_FORMS, { customForms }),
  setApplicantCount: (jobId: number, customForms: Partial<IDabellaCustomFormData>[]) =>
    createAction(SET_APPLICANT_COUNT, { jobId, customForms }),
  updateDabellaForm: (event: FormUpdateEvent) => createAction(UPDATE_DABELLA_FORM, { event }),
  resetDabellaForm: () => createAction(RESET_DABELLA_FORM),
  cleanupDabellaForm: () => createAction(CLEANUP_DABELLA_FORM),
};

export type DabellaCustomFormActions = ActionsUnion<typeof DabellaCustomFormActions>;
